import { coerce, create, defaulted, Infer, mask, object, string, validate } from "superstruct"
import * as qs from "querystringify"

import { SentryWrapper } from "../../../../utils/ThirdParty/Sentry/SentryWrapper"
import { MAX_PRICE, MIN_PRICE, MAX_AGE, MIN_AGE } from "../../../PsyProfile/common/constants"

import { parseArrayOfNumbers, parseBool, parseEnums, parseNumber, parseString } from "./parsers"

import { SessionTimeInterval } from "utils/interfaces"

export const city = parseString("any")
export const form_of_work = parseEnums(["in_person", "online", "any"], "any")
export const sex = parseEnums(["M", "F", "any"], "any")
export const marital_status = parseEnums(["married", "single", "any"], "any")
export const has_children = parseEnums(["yes", "no", "any"], "any")
export const price_from = parseNumber(MIN_PRICE, MAX_PRICE, MIN_PRICE)
export const price_to = parseNumber(MIN_PRICE, MAX_PRICE, MAX_PRICE)
export const age_from = parseNumber(MIN_AGE, MAX_AGE, MIN_AGE)
export const age_to = parseNumber(MIN_AGE, MAX_AGE, MAX_AGE)
export const competences = parseArrayOfNumbers(1, 1000)
export const methods = parseArrayOfNumbers(1, 1000)
export const working_with = defaulted(
    object({
        friendly: parseBool(),
        fem: parseBool(),
        believer: parseBool(),
        elderly: parseBool(),
        foreigner: parseBool(),
        cancer: parseBool(),
    }),
    () => ({
        friendly: false,
        fem: false,
        believer: false,
        elderly: false,
        foreigner: false,
        cancer: false,
    })
)
export const express_slots = parseBool()

const QuerySchema = object({
    city,
    form_of_work,
    sex,
    marital_status,
    has_children,
    price_from,
    price_to,
    age_from,
    age_to,
    competences,
    methods,
    working_with,
    express_slots,
})

export const defaultQuery: CatalogSearchQuery = create({}, QuerySchema)

export const SearchQuerySchema = coerce(QuerySchema, string(), (str) => {
    const entries = qs.parse(str) as Record<string, string>
    const nested = new Map<string, (readonly [string, string])[]>()
    for (const key in entries) {
        const parts = key.split(".")
        if (parts.length > 1) {
            const entry = [parts[1], entries[key]] as const
            if (nested.has(parts[0])) {
                nested.get(parts[0])?.push(entry)
            } else {
                nested.set(parts[0], [entry])
            }
        }
    }

    const nestedEntries: Record<string, Record<string, string>> = {}

    for (const [key, value] of nested) {
        nestedEntries[key] = Object.fromEntries(value)
    }

    const result = { ...mask(entries, QuerySchema), ...nestedEntries }

    const [err, SearchQuery] = validate(result, QuerySchema, { coerce: true })

    if (err) {
        SentryWrapper.getInstance().captureException(err)
        return defaultQuery
    } else {
        return SearchQuery
    }
})

export type CatalogSearchQuery = Infer<typeof QuerySchema>
export type CatalogSearchQueryKey = keyof CatalogSearchQuery
export interface FormState extends CatalogSearchQuery {
    session_time_intervals: SessionTimeInterval[]
}
